import React from "react";
import styled from "styled-components";

import HorizontalScroll from "react-scroll-horizontal";
import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import Layout from "../../components/Layout/Layout";

const StaticReviews = () => {
  return (
    <Layout>
      {/*  Header */}
      <Header showBuildMyBed showCart cartIconColor={"#0F475D"} />
      {/*  Body */}

      <main
        style={{
          margin: "0 auto",
          height: "90vh",
          overflow: "hidden",
          // overscrollBehavior: "contain",
          padding: "0 0px",
          zIndex: 300,
        }}
      >
        <TitleShadow>Reviews</TitleShadow>
        <Title>what people have to say</Title>
        <HorizontalScroll
          reverseScroll={true}
          style={{ width: "100vw", paddingLeft: "100px" }}
        >
          <CardsContainer>
            <Card style={{ minWidth: "600px" }}>
              <DecoratorContainer>
                <Decorator />
                <Decorator />
              </DecoratorContainer>
              <p>
                Hands down the best mattress business model and service in the
                business.
                <br />
                The modular mattress system allows you to customize the firmness
                to your desired levels. Not happy? No problems. You can exchange
                the modules as many times m as needed in the first 4 months to
                get your firmness just right. I probably exchanged mine 6-7
                times and every time the staff was super helpful and did their
                best to accommodate me.
              </p>
              <p>
                Pricing wise it’s pretty similar to high end mattresses from the
                top end companies but there’s no substitute for service and
                customizing your mattress which is where Sleep Boutique excels.
                Will never buy mattress from any other store again.
              </p>

              <ReviewRating>
                <StarsContainer>
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                </StarsContainer>

                <span style={{ fontSize: "16px", color: "#6AA1B8" }}>
                  Kiran Somanchi
                </span>
                <span style={{ fontSize: "14px", color: "#6AA1B8" }}>
                  2 months ago
                </span>
              </ReviewRating>
            </Card>
            <Card style={{ minWidth: "600px" }}>
              <DecoratorContainer>
                <Decorator />
                <Decorator />
              </DecoratorContainer>
              <p>
                We purchased a new...king bed over 18 months ago, and it
                occurred to me I have shared so many positive reviews with
                friends and family and clients, and many are purchasing new
                mattresses now...but I had not yet posted a public review.
              </p>
              <p>
                Purchasing our new mattress was a great experience - we spent
                hours discussing and trying out options. Customer service is
                some of the best I have experienced. We continue to be extremely
                happy with our mattress and are always happy to recommend Colin
                and his team to everyone we know who is looking for a new bed.
              </p>

              <ReviewRating>
                <StarsContainer>
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                </StarsContainer>

                <span style={{ fontSize: "16px", color: "#6AA1B8" }}>
                  Jennifer Pidlubny
                </span>
                <span style={{ fontSize: "14px", color: "#6AA1B8" }}>
                  4 months ago
                </span>
              </ReviewRating>
            </Card>
            <Card style={{ minWidth: "400px" }}>
              <DecoratorContainer>
                <Decorator />
                <Decorator />
              </DecoratorContainer>
              <p>
                Just received and assembled our new modular... mattress . Can’t
                tell you how happy we are after spending only two nights on it
                and it is as comfortable as advertised. The best part is that my
                wife and I prefer different firmnesses and it has worked out
                perfectly.
              </p>

              <ReviewRating>
                <StarsContainer>
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                </StarsContainer>

                <span style={{ fontSize: "16px", color: "#6AA1B8" }}>
                  Eric von Colditz
                </span>
                <span style={{ fontSize: "14px", color: "#6AA1B8" }}>
                  1 year ago
                </span>
              </ReviewRating>
            </Card>
            <Card style={{ minWidth: "600px" }}>
              <DecoratorContainer>
                <Decorator />
                <Decorator />
              </DecoratorContainer>
              <p>
                Hands down the best mattress business model and service in the
                business.
                <br />
                The modular mattress system allows you to customize the firmness
                to your desired levels. Not happy? No problems. You can exchange
                the modules as many times m as needed in the first 4 months to
                get your firmness just right. I probably exchanged mine 6-7
                times and every time the staff was super helpful and did their
                best to accommodate me.
              </p>
              <p>
                Pricing wise it’s pretty similar to high end mattresses from the
                top end companies but there’s no substitute for service and
                customizing your mattress which is where Sleep Boutique excels.
                Will never buy mattress from any other store again.
              </p>

              <ReviewRating>
                <StarsContainer>
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                  <StarSVG />
                </StarsContainer>

                <span style={{ fontSize: "16px", color: "#6AA1B8" }}>
                  Kiran Somanchi
                </span>
              </ReviewRating>
            </Card>
          </CardsContainer>
        </HorizontalScroll>
        <LeafDecorator />
        <LeafDecorator
          style={{
            width: "8vw",
            height: "100px",
            top: "66%",
            left: "20%",
            borderWidth: "2px",
            position: "relative",
            zIndex: 80,
            opacity: 0.05,
          }}
        />
      </main>

      {/*  Footer */}
      <Footer showMenuButton={true} styles={{ zIndex: 1100 }}></Footer>
    </Layout>
  );
};

export default StaticReviews;

const Card = styled.div`
  color: #0f475d;
  background-color: #e2f3fd;
  border-radius: 0 190px 0 190px;
  font-size: 14px;
  padding: 32px 40px 32px 32px;
  letter-spacing: 0;
  font-family: noto-sans;
  height: 540px;
  display: flex;
  flex-direction: column;
  //min-width: 600px;
  z-index: 99;
`;

const DecoratorContainer = styled.div`
  display: flex;
  gap: 10px;
  padding-bottom: 16px;
`;

const Decorator = styled.div`
  background-color: #b9e6fa;
  border-radius: 0 45% 0 45%;
  width: 40px;
  height: 56px;
`;

const LeafDecorator = styled.div`
  border-radius: 50% 0 50% 0;
  border: 8px solid #b1d34a;
  width: 300px;
  height: 300px;
  position: absolute;
  left: 66%;
  top: 10%;
  opacity: 7%;
`;

const ReviewRating = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0px;
  padding: 0px 0;
`;

const StarsContainer = styled.div`
  display: flex;
  margin-left: -4px;
`;

const Title = styled.h1`
  color: #0f475d;
  font-size: 84px;
  font-family: elena-web-basic;
  font-weight: bold;
  margin-top: -100px;
  margin-left: 250px;
  margin-bottom: 45px;
`;

const TitleShadow = styled.div`
  color: #6aa1b8;
  font-family: elena-web-basic;
  font-size: 137px;
  opacity: 16%;
  font-weight: bold;
  margin-top: -20px;
  margin-left: 100px;
`;

const CardsContainer = styled.div`
  display: flex;
  gap: 64px;
  //margin-left: 20%;
  height: auto;
  margin-right: 32px;

  & ${Card}:last-child {
    padding-right: 36px;
    margin-right: 36px;
  }
`;

const StarSVG = () => (
  <svg
    fill="#B1D34A"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    id="star_filled"
    data-name="star filled"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      id="Rectangle_4"
      data-name="Rectangle 4"
      width="24"
      height="24"
      fill="none"
    />
    <path
      id="Star"
      d="M10,15,4.122,18.09l1.123-6.545L.489,6.91l6.572-.955L10,0l2.939,5.955,6.572.955-4.755,4.635,1.123,6.545Z"
      transform="translate(2 3)"
    />
  </svg>
);
